import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ClearingCoursesEmptyStateComponent } from '../../../components/clearing/clearing-courses-empty-state/clearing-courses-empty-state.component';
import { ClearingCourseSearchComponent } from '../clearing-course-search/clearing-course-search.component';
import { CLEARING_ENABLED } from '@uc/web/config';

@Component({
	selector: 'uc-clearing-course-search-container',
	imports: [ClearingCoursesEmptyStateComponent, ClearingCourseSearchComponent],
	templateUrl: './clearing-course-search-container.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClearingCourseSearchContainerComponent {
	subject = input.required<string>();
	// queryparams
	degree = input<string>();
	mode = input<string>();
	ucaspts = input<string>();
	page = input<string>();
	search = input<string>();
	location = input<string>();

	clearingEnabled = CLEARING_ENABLED;
}
